import { Link } from "react-router-dom";
import {
  Shield,
  Zap,
  Globe,
  Eye,
  Power,
  Wifi,
  ChevronRight,
  Check,
  X as XIcon,
  Download,
  Smartphone,
  Lock,
  Users,
  Clock,
  ArrowRight,
  Play,
  Apple,
  HelpCircle,
  CreditCard,
  AlertTriangle,
  Cpu,
  Hourglass,
  ShieldCheck,
  MessageCircle,
  Sparkles,
  CalendarDays,
  Info,
} from "lucide-react";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { SITE_CONFIG, PRICING_CONFIG, PRIVACY_CONFIG } from "@/config/site";

import shieldImg from "../assets/iconsax-security-safe.svg";
import androidImg from "../assets/iconsax-android-new.svg";
import iOSImg from "../assets/iconsax-apple-new.svg";
import android2Img from "../assets/icon-android2.svg";
import iOS2Img from "../assets/icon-ios2.svg";
import encryptImg from "../assets/icon-quantum-encryption.svg";
import actlogImg from "../assets/icon-zero-activity.svg";
import securepayImg from "../assets/icon-secure-payments.svg";
import allsupportImg from "../assets/icon-24_7-support.svg";
import qvpnsearchImg from "../assets/iconsax-shield-search.svg";
import padlockImg from "../assets/iconsax-padlock.svg";
import publicWifiImg from "../assets/icon-public-wifi.svg";
import futureProofImg from "../assets/icon-future-proof.svg";
import travelSafeImg from "../assets/icon-travel-security.svg";
import quantumSafeImg from "../assets/icon-quantum-safe.svg";
import featureblkImg from "../assets/iconsax-global-refresh.svg";
import quantumprotoImg from "../assets/icon-quantum-protocol.svg";
import globalserverImg from "../assets/icon-globalservers.svg";
import zerologsImg from "../assets/icon-zero-logs.svg";
import killswitchImg from "../assets/icon-kill-switch.svg";
import autoconnImg from "../assets/icon-auto-connect.svg";
import onetapproImg from "../assets/icon-onetap.svg";
import howitworksImg from "../assets/iconsax-mobile.svg";
import downloadappImg from "../assets/icon-downloadapp.svg";
import connwifiImg from "../assets/icon-connectwifi.svg";
import browsesafeImg from "../assets/icon-browsesafe.svg";
import whyquantumImg from "../assets/iconsax-security-safe2.svg";
import harvestImg from "../assets/icon-harvestnow.svg";
import postquantumImg from "../assets/icon-postquantum.svg";
import tickingclockImg from "../assets/icon-tickingclock.svg";
import tryqvpnImg from "../assets/icon-tryqvpn.svg";
import goquantumImg from "../assets/icon-goquantum.svg";

import scrollToSection from "@/utils/scrollToSection";

// Star Field Background Component
const StarField = () => {
  const stars = Array.from({ length: 50 }, (_, i) => ({
    id: i,
    left: `${Math.random() * 100}%`,
    top: `${Math.random() * 100}%`,
    animationDelay: `${Math.random() * 3}s`,
    size: Math.random() * 2 + 1,
  }));

  return (
    <div className="star-field">
      {stars.map((star) => (
        <div
          key={star.id}
          className="star"
          style={{
            left: star.left,
            top: star.top,
            width: `${star.size}px`,
            height: `${star.size}px`,
            animationDelay: star.animationDelay,
          }}
        />
      ))}
    </div>
  );
};

// Hero Section
const HeroSection = () => {
  return (
    <section
      className="relative min-h-screen flex items-center pt-241 hero-padd hero-ht overflow-hidden hero-gradient"
      data-testid="hero-section"
    >
      <StarField />

      {/* Glow Orbs */}
      <div className="glow-orb glow-orb-purple w-[600px] h-[600px] -top-40 -left-40 absolute" />
      <div className="glow-orb glow-orb-blue w-[400px] h-[400px] top-1/2 right-0 absolute" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 qsafe-blk">
        <div className="text-center max-w-4xl mx-auto">
          {/* Badge */}
          {/* <div className="inline-flex items-center gap-2 mb-8 animate-fade-in">
            <Badge className="section-badge">
              <ShieldCheck className="w-3 h-3 text-violet-400" />
              <span>Quantum Safe VPN</span>
            </Badge>
          </div> */}
          <div className="qvpn-safe-btn" id="download">
            <img src={shieldImg} alt="Quantum Safe VPN" /> Quantum Safe VPN
          </div>

          {/* Main Headline */}
          <h1
            className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold tracking-tight mb-6 animate-fade-in-up"
            style={{ animationDelay: "0.1s" }}
          >
            <span className="text-white">Privacy That Outlasts</span>
            {/* <br />
            <span className="gradient-text"> </span> */}
            <br />
            <span className="text-white">Quantum Computers</span>
          </h1>

          {/* Subheadline */}
          <p
            className="text-base md:text-lg text-gray-400 max-w-2xl mx-auto mb-10 leading-relaxed animate-fade-in-up"
            style={{ animationDelay: "0.2s" }}
          >
            The first VPN built for the post quantum era. Protect your data
            against today's hackers and tomorrow's quantum attacks.
          </p>

          {/* CTA Buttons */}
          <div
            className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-161 hero-btn-blk animate-fade-in-up"
            style={{ animationDelay: "0.3s" }}
          >
            {/* <Link to="/#download">
              <Button
                className="btn-primary flex btn-padd items-center gap-2 w-full sm:w-auto"
                data-testid="hero-get-started-btn"
              >
                Get Started Free
                <ChevronRight className="w-4 h-4" />
              </Button>
            </Link> */}
            <Link to="/pricing">
              <Button
                className="btn-secondary1 btn-gradient-new flex btn-padd items-center gap-2 w-full sm:w-auto"
                data-testid="hero-pricing-btn"
              >
                View Pricing
              </Button>
            </Link>
          </div>

          {/* App Store Badges */}
          {/* <div
            className="flex flex-col sm:flex-row justify-center gap-4 animate-fade-in-up"
            style={{ animationDelay: "0.4s" }}
          >

            <div className="flex flex-col items-center">
            <a
              href={SITE_CONFIG.appLinks.googlePlay.url}
              className="icon-android-app flex items-center justify-center min-w-[170px]"
              data-testid="google-play-link"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={androidImg} alt="Quantum Safe VPN" />
              Android App
            </a>
            </div>

            <div className="flex flex-col items-center">
              <a
                href={SITE_CONFIG.appLinks.appStore.url}
                className="icon-iphone-app flex items-center justify-center min-w-[170px]"
                data-testid="app-store-link"
              >
                <img src={iOSImg} alt="Quantum Safe VPN" />
                iOS App
              </a>
            </div>
          </div> */}

          <div
            className="flex flex-col sm:flex-row justify-center items-center gap-4 animate-fade-in-up h-icon"
            style={{ animationDelay: "0.4s" }}
          >
            {/* Android */}
            <a
              href={SITE_CONFIG.appLinks.googlePlay.url}
              className="icon-android-app flex items-center justify-center min-w-[180px]"
              data-testid="google-play-link"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={androidImg} alt="Quantum Safe VPN" />
              {/* <span>Android App</span> */}
              <div className="flex flex-col items-start leading-none py-1.5">
                <span className="ios-title">Android App</span>
                {/* <span className="ios-coming-text">COMING SOON</span> */}
              </div>
            </a>

            {/* iOS */}
            <a
              href={SITE_CONFIG.appLinks.appStore.url}
              className="icon-iphone-app flex items-center justify-center min-w-[180px]"
              data-testid="app-store-link"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={iOSImg} alt="Quantum Safe VPN" />

              <div className="flex flex-col items-start leading-none">
                <span className="ios-title">iOS App</span>
                {/* <span className="ios-coming-text">COMING SOON</span> */}
              </div>
            </a>
          </div>

        </div>
      </div>

      {/* Bottom Gradient Fade */}
      {/* <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-[#0a0a0f] to-transparent" /> */}
    </section>
  );
};

// Feature Icons Row (Trust Section)
const FeatureIconsRow = () => {
  // const items = [
  //   { icon: Lock, text: "Quantum Encryption" },
  //   { icon: Eye, text: "Zero Activity Logs" },
  //   { icon: CreditCard, text: "Secure Payments" },
  //   { icon: MessageCircle, text: "24/7 Support" }
  // ];

  return (
    <section
      className="py-12 border-y border-white/5 bg-white/[0.02]1 bg-black-v1"
      data-testid="trust-section"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          <div className="text-center">
            <div className="flex items-center justify-center mb-3">
              <div className="icon-container1">
                <img src={encryptImg} alt="Quantum Encryption" />
              </div>
            </div>
            <div className="text-sm text-gray-400">Quantum Encryption</div>
          </div>

          <div className="text-center">
            <div className="flex items-center justify-center mb-3">
              <div className="icon-container1">
                <img src={actlogImg} alt="Zero Activity Logs" />
              </div>
            </div>
            <div className="text-sm text-gray-400">Zero Activity Logs</div>
          </div>

          <div className="text-center">
            <div className="flex items-center justify-center mb-3">
              <div className="icon-container1">
                <img src={securepayImg} alt="Secure Payments" />
              </div>
            </div>
            <div className="text-sm text-gray-400">Secure Payments</div>
          </div>

          <div className="text-center">
            <div className="flex items-center justify-center mb-3">
              <div className="icon-container1">
                <img src={allsupportImg} alt="24/7 Support" />
              </div>
            </div>
            <div className="text-sm text-gray-400">24/7 Support</div>
          </div>
        </div>
      </div>
    </section>
  );
};

// What is QVPN Section
const WhatIsSection = () => {
  return (
    <section
      className="relative py-20 bg-white/[0.02]1 bg-black-v1"
      data-testid="what-is-section"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mx-auto text-center">
          {/* <Badge className="section-badge mb-6">
            <HelpCircle className="w-3 h-3 text-violet-400" />
            <span>What is QVPN?</span>
          </Badge> */}
          <div className="qvpn-safe-btn">
            <img src={qvpnsearchImg} alt="What is QVPN" /> What is QVPN?
          </div>
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight mb-6 animate-fade-in-up">
            Your Privacy, Quantum Protected
          </h2>
          <p className="text-gray-400 text-lg leading-relaxed mb-4">
            QVPN is a quantum safe VPN that encrypts your internet connection
            using post quantum cryptography. Unlike traditional VPNs, QVPN
            protects your data against both current cyber threats and future
            quantum computer attacks.
          </p>
          <p className="text-gray-400 text-lg leading-relaxed mb-8">
            Your browsing activity stays private. Your data stays secure. Today
            and tomorrow.
          </p>

          {/* Privacy Statement */}
          <div className="bg-white/[0.03] border border-white/10 rounded-2xl p-6 text-left">
            <h3 className="text-white font-semibold mb-4 flex items-center gap-2">
              {/* <Lock className="w-5 h-5 text-violet-400" /> */}
              <img src={padlockImg} alt="Privacy Commitment" />
              Our Privacy Commitment
            </h3>
            <ul className="space-y-3 text-gray-400 text-sm">
              <li className="flex items-start gap-3 list-txt">
                <Check className="w-4 h-4 text-emerald-400 mt-0.5 flex-shrink-0" />
                <span>
                  We do not log or monitor your browsing activity while
                  connected to QVPN.
                </span>
              </li>
              <li className="flex items-start gap-3 list-txt">
                <Check className="w-4 h-4 text-emerald-400 mt-0.5 flex-shrink-0" />
                <span>
                  We do not use your data for advertising or sell it to third
                  parties.
                </span>
              </li>
              <li className="flex items-start gap-3 list-txt">
                <Check className="w-4 h-4 text-emerald-400 mt-0.5 flex-shrink-0" />
                <span>
                  We collect only the minimum information necessary to operate
                  the service, manage your account, and provide support.
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

// Use Cases Section
const UseCasesSection = () => {
  const useCases = [
    {
      icon: publicWifiImg,
      title: "Public Wi-Fi Protection",
      description:
        "Stay secure on coffee shop, airport, and hotel networks. Your data is encrypted and protected from snoopers.",
    },
    {
      icon: quantumSafeImg,
      title: "Quantum Safe Browsing",
      description:
        "Add post quantum encryption to your everyday browsing. Keep your online activities private against current and future threats.",
    },
    {
      icon: travelSafeImg,
      title: "Travel Security",
      description:
        "Access your accounts securely while traveling. Connect with confidence from anywhere in the world.",
    },
    {
      icon: futureProofImg,
      title: "Future Proof Protection",
      description:
        "Quantum safe encryption that protects your data today and remains secure against tomorrow's quantum computers.",
    },
  ];

  return (
    <section
      className="relative py-201 when-padd bg-black-v2"
      data-testid="use-cases-section"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight mb-6 animate-fade-in-up">
            When to Use QVPN
          </h2>
          <p className="text-gray-400 text-lg leading-relaxed mb-4">
            Protect yourself in everyday situations where your privacy matters.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {useCases.map((useCase, index) => (
            <div
              key={index}
              className="p-6 mob-vpn rounded-2xl bg-white/[0.03] border border-white/10 hover:border-white/20 transition-colors duration-300"
            >
              <div className="icon-container1 mb-4">
                {/* <useCase.icon className="w-5 h-5 text-violet-400" /> */}
                <img src={useCase.icon} alt={useCase.title} />
              </div>
              <h3 className="text-lg font-semibold text-white mb-2">
                {useCase.title}
              </h3>
              <p className="text-gray-400 text-sm">{useCase.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

// Features Section
const FeaturesSection = () => {
  const features = [
    {
      icon: quantumprotoImg,
      title: "Quantum Safe Protocol",
      description:
        "Built on post quantum cryptography for fast, secure connections that remain protected against quantum decryption.",
    },
    {
      icon: globalserverImg,
      title: "Global Servers",
      description:
        "Connect to servers around the world for reliable access wherever you are.",
    },
    {
      icon: zerologsImg,
      title: "Zero Logs Policy",
      description:
        "We don't log your browsing activity or use your data for advertising. Your privacy comes first.",
    },
    {
      icon: killswitchImg,
      title: "Kill Switch",
      description:
        "Automatic protection that blocks internet traffic if your VPN connection drops unexpectedly.",
    },
    {
      icon: autoconnImg,
      title: "Connect",
      description:
        "Connect to QVPN when joining untrusted networks like public Wi-Fi.",
    },
    {
      icon: onetapproImg,
      title: "One Tap Protection",
      description:
        "Easy-to-use apps for Android and iOS. Connect with one tap.",
    },
  ];

  return (
    <section
      id="features"
      className="relative py-24 md:py-10 bg-black-v2"
      data-testid="features-section"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          {/* <Badge className="section-badge mb-6">
            <Shield className="w-3 h-3 text-violet-400" />
            <span>Features</span>
          </Badge> */}
          <div className="qvpn-safe-btn">
            <img src={featureblkImg} alt="Features" /> Features
          </div>
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight mb-6 animate-fade-in-up">
            Everything You Need
          </h2>
          <p className="text-gray-400 text-lg leading-relaxed mb-4">
            Simple, powerful VPN features designed with your privacy in mind.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {features.map((feature, index) => (
            <div
              key={index}
              className="feature-card group relative p-10 rounded-3xl bg-white/[0.03] border border-white/10 hover:border-white/20 transition-colors duration-300 overflow-hidden"
              data-testid={`feature-card-${index}`}
            >
              <div className="icon-container1 mb-6 group-hover:scale-110- transition-transform- duration-300">
                {/* <feature.icon className="w-5 h-5 text-violet-400" /> */}
                <img src={feature.icon} alt={feature.title} />
              </div>
              <h3 className="text-xl font-semibold text-white mb-3">
                {feature.title}
              </h3>
              <p className="text-gray-400 leading-relaxed">
                {feature.description}
              </p>
              <div className="absolute -bottom-20 -right-20 w-40 h-40 bg-emerald-600/20 rounded-full blur-3xl opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
            </div>
          ))}
        </div>
      </div>

      <div className="glow-orb glow-orb-purple w-[300px] h-[300px] top-1/4 -left-32 absolute" />
    </section>
  );
};

// How It Works Section
const HowItWorksSection = () => {
  const steps = [
    {
      number: "01",
      icon: downloadappImg,
      title: "Download the App",
      description:
        "Get QVPN from the Google Play Store or Apple App Store. Available for all major platforms.",
    },
    {
      number: "02",
      icon: connwifiImg,
      title: "Connect with One Tap",
      description:
        "Open the app and tap connect. We'll automatically select the fastest server for you.",
    },
    {
      number: "03",
      icon: browsesafeImg,
      title: "Browse Quantum Safe",
      description:
        "Your connection is now protected with post quantum encryption. Browse, stream, and work knowing your data is secure.",
    },
  ];

  return (
    <section
      id="how-it-works"
      className="relative py-24 md:py-25 bg-black-v2 works-padd"
      data-testid="how-it-works-section"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          {/* <Badge className="section-badge mb-6">
            <Clock className="w-3 h-3 text-violet-400" />
            <span>How It Works</span>
          </Badge> */}
          <div className="qvpn-safe-btn">
            <img src={howitworksImg} alt="How It Works" />
            How It Works
          </div>
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight mb-8 animate-fade-in-up">
            Get Started in Minutes
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 relative numblk">
          {/* <div className="hidden md:block absolute top-24 left-1/3 right-1/3 h-px">
            <div className="connection-line w-full" />
          </div> */}

          {steps.map((step, index) => (
            <div
              key={index}
              className="relative text-center p-8"
              data-testid={`step-${index + 1}`}
            >
              <div className="step-number">{step.number}</div>
              <div className="relative z-50 mx-auto mb-6 w-20 h-20 rounded-2xl flex items-center justify-center countimg">
                {/* <step.icon className="w-8 h-8 text-violet-400" /> */}
                <img src={step.icon} alt={step.title} />
              </div>
              <h3 className="relative z-10 text-xl font-semibold text-white mb-3">
                {step.title}
              </h3>
              <p className="relative z-10 text-gray-400">{step.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

// Why Quantum Section (NEW)
const WhyQuantumSection = () => {
  const cards = [
    {
      icon: harvestImg,
      title: "Harvest Now, Decrypt Later",
      label: "The Problem",
      body: "Hackers and state actors are already collecting encrypted data today, waiting for quantum computers powerful enough to break traditional encryption. Your banking details, private messages, and sensitive documents could be at risk.",
    },
    {
      icon: postquantumImg,
      title: "Post Quantum Cryptography",
      label: "The Solution",
      body: "QVPN uses encryption algorithms specifically designed to resist quantum computer attacks. Based on mathematical problems that remain hard even for quantum computers, your data stays protected no matter what the future holds.",
    },
    {
      icon: tickingclockImg,
      title: "The Clock is Ticking",
      label: "The Timeline",
      body: "Experts predict quantum computers capable of breaking current encryption could arrive within 5 to 10 years. Organizations like Google, governments, and security agencies are already transitioning to post quantum cryptography. QVPN brings this protection to you today.",
    },
  ];

  return (
    <section
      className="relative py-24 md:py-32 bg-white/[0.02]1 bg-black-v1 treat-padd"
      data-testid="why-quantum-section"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          {/* <Badge className="section-badge mb-6">
            <Sparkles className="w-3 h-3 text-violet-400" />
            <span>Why Quantum?</span>
          </Badge> */}
          <div className="qvpn-safe-btn">
            <img src={whyquantumImg} alt="Why Quantum" /> Why Quantum?
          </div>
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight mb-6 animate-fade-in-up">
            The Quantum Threat is Real
          </h2>
          <p className="text-base md:text-lg text-gray-400 max-w-2xl mx-auto">
            Today's encrypted data can be stored and decrypted tomorrow when
            quantum computers arrive.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
          {cards.slice(0, 2).map((card, index) => (
            <div
              key={index}
              className="p-8 rounded-3xl bg-white/[0.03] border border-white/10 hover:border-white/20 transition-colors duration-300"
              data-testid={`why-quantum-card-${index}`}
            >
              <div className="flex items-center gap-3 mb-4">
                <div className="icon-container1">
                  {/* <card.icon className="w-5 h-5 text-violet-400" /> */}
                  <img src={card.icon} alt={card.title} />
                </div>
                <span className="text-xs font-medium text-violet-300 uppercase tracking-wide quantum-ft">
                  {card.title}
                </span>
              </div>
              {/* <h3 className="text-xl font-semibold text-white mb-3">
                {card.title}
              </h3> */}
              <p className="text-gray-400 leading-relaxed text-sm">
                {card.body}
              </p>
            </div>
          ))}
        </div>

        {/* Wide card for the third */}
        <div
          className="p-8 rounded-3xl bg-white/[0.03] border border-white/10 hover:border-white/20 transition-colors duration-300 mb-10"
          data-testid="why-quantum-card-2"
        >
          <div className="flex items-center gap-3 mb-4">
            <div className="icon-container1">
              {/* <Hourglass className="w-5 h-5 text-violet-400" /> */}
              <img src={tickingclockImg} alt={cards[2].title} />
            </div>
            <span className="text-xs font-medium text-violet-300 uppercase tracking-wide quantum-ft">
              {cards[2].title}
            </span>
          </div>
          {/* <h3 className="text-xl font-semibold text-white mb-3">
            {cards[2].title}
          </h3> */}
          <p className="text-gray-400 leading-relaxed text-sm max-w-4xl">
            {cards[2].body}
          </p>
        </div>

        {/* <div className="text-center">
          <Button
            className="btn-primary inline-flex items-center gap-2 btn-padd"
            data-testid="why-quantum-cta"
          >
            Learn More About Quantum Security
            <ArrowRight className="w-4 h-4" />
          </Button>
        </div> */}
      </div>
    </section>
  );
};

// Comparison Section (NEW)
const ComparisonSection = () => {
  const rows = [
    { feature: "Current threat protection", traditional: true, qvpn: true },
    { feature: "Quantum attack protection", traditional: false, qvpn: true },
    { feature: "Future proof encryption", traditional: false, qvpn: true },
    { feature: "Zero logs policy", traditional: "Varies", qvpn: true },
    { feature: "Post quantum cryptography", traditional: false, qvpn: true },
  ];

  const renderCell = (value) => {
    if (value === true)
      return <Check className="w-5 h-5 text-emerald-400 mx-auto" />;
    if (value === false)
      return <XIcon className="w-5 h-5 text-gray-600 mx-auto" />;
    return <span className="text-gray-400 text-sm">{value}</span>;
  };

  return (
    <section
      className="relative py-24 md:py-25 bg-black-v2 trad-padd"
      data-testid="comparison-section"
    >
      <div className="max-w-5xl mx-auto  px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl trad-title font-bold tracking-tight mb-8 animate-fade-in-up">
            QVPN vs Traditional VPNs
          </h2>
        </div>

        <div className="rounded-3xl bg-white/[0.03] border border-white/10 overflow-hidden">
          {/* Header */}
          <div className="grid grid-cols-3 border-b border-white/10">
            <div className="p-4 md:p-6 text-sm font-medium text-gray-300">
              Feature
            </div>
            <div className="p-4 md:p-6 text-sm font-medium text-gray-300 text-center">
              Traditional VPNs
            </div>
            <div className="p-4 md:p-6 text-sm font-semibold text-violet-3001 text-center qvpn-ft">
              QVPN
            </div>
          </div>

          {/* Body */}
          {rows.map((row, i) => (
            <div
              key={i}
              className={`grid grid-cols-3 ${i !== rows.length - 1 ? "border-b border-white/5" : ""}`}
              data-testid={`comparison-row-${i}`}
            >
              <div className="p-4 md:p-6 text-sm text-gray-300">
                {row.feature}
              </div>
              <div className="p-4 md:p-6 text-center">
                {renderCell(row.traditional)}
              </div>
              <div className="p-4 md:p-6 text-center">
                {renderCell(row.qvpn)}
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-10 trad-btn-blk">
          <Link to="/pricing">
            <Button
              className="btn-primary1 btn-gradient-new inline-flex items-center gap-2 btn-padd"
              data-testid="comparison-cta"
            >
              Get Quantum Protection
              <ChevronRight className="w-4 h-4" />
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
};

// Device Compatibility Section (NEW)
const DeviceCompatibilitySection = () => {
  const devices = [
    {
      icon: android2Img,
      name: "Android",
      description: "Seamless experience across all Android devices",
    },
    {
      icon: iOS2Img,
      name: "iOS",
      description: "Fully compatible with iPhone and iPad",
    },
  ];

  return (
    <section
      className="relative py-241 devices-padd md:py-251 bg-white/[0.02]1 bg-black-v2"
      data-testid="device-compatibility-section"
    >
      <div className="device-top"></div>
      <div className="device-bottom"></div>
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          {/* <Badge className="section-badge mb-6">
            <Globe className="w-3 h-3 text-violet-400" />
            <span>Works Everywhere</span>
          </Badge> */}
          <div className="qvpn-safe-btn">
            <img src={featureblkImg} alt=" Works Everywhere" /> Works Everywhere
          </div>
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight mb-8 animate-fade-in-up">
            Works with Your Devices
          </h2>
          <p className="text-base md:text-lg text-gray-400 s">
            One plan covers everything.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-10">
          {devices.map((device, index) => (
            <div
              key={index}
              className="mob-devicons p-3 rounded-2xl bg-white/[0.03] border border-white/10 hover:border-white/20 transition-colors duration-300"
              data-testid={`device-card-${index}`}
            >
              <div className="flex items-center gap-4 mb-3">
                <div className="w-12 h-12 rounded-xl flex items-center justify-center icon2img">
                  {/* <device.icon className="w-6 h-6 text-violet-400" /> */}
                  <img src={device.icon} alt={device.name} />
                </div>
                <h3 className="text-xl font-semibold text-white">
                  {device.name}
                </h3>
              </div>
              <p className="text-gray-400 text-sm">{device.description}</p>
            </div>
          ))}
        </div>

        <div className="text-center device-btn-blk">
          <Link to="/pricing">
            <Button
              className="btn-primary1 btn-gradient-new inline-flex items-center gap-2 btn-padd"
              data-testid="device-compatibility-cta"
            >
              Choose a Plan
              <ChevronRight className="w-4 h-4" />
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
};

// Pricing Preview Section (3-tier)
const PricingPreviewSection = () => {
  const plans = PRICING_CONFIG.quantumPlans;

  return (
    <section
      id="pricing-preview"
      className="relative py-241 md:py-251 bg-black-v1 plan-home-padd"
      data-testid="pricing-preview-section"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="plan-home-title text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight mb-0 animate-fade-in-up">
            A Plan for Everyone
          </h2>
          <p className="text-lg text-gray-400 max-w-2xl mx-auto">
            Get quantum safe protection with a plan that fits your needs. Start
            free or save up to 70% with longer terms.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-y-12 md:gap-6 lg:gap-8">
          <div
            className="group relative overflow-visible p-8 rounded-3xl flex flex-col mob-bottoms h-full transition-all duration-500
                ease-out hover:-translate-y-2 hover:scale-[1.01] hover:shadow-[0_0_35px_rgba(16,185,129,0.12)] mb-10- bg-white/[0.03] border border-white/10 cardbg1"
          >
            {/* <div className="absolute -top-3 left-6 w-max z-10">
                  <span className="px-4 py-1 rounded-full tag">
                    BADGE
                  </span>
                </div> */}

            <div className="mb-6">
              <h2 className="text-2xl font-bold text-white mb-1">STANDARD</h2>
              <p className="white-text-400 text-sm"></p>
            </div>

            <div className="mb-6">
              <div className="flex items-baseline">
                <span className="text-3xl md:text-5xl font-bold text-white">
                  $0
                </span>
              </div>
              <div className="text-sm white-text-4001 text-gray-300 mt-2">
                Essential VPN protection
              </div>
              <div className="text-xs white-text-500 mt-1"></div>
              {/* <div className="inline-block mt-3 px-2 py-0.5 text-xl font-medium text-emerald-400 bg-emerald-500/10 rounded-full">
                  Save 50%
                </div> */}
            </div>

            <div className="border-t border-white/10 pt-3 mb-8 space-y-4">
              <div className="flex items-center justify-between border-b border-white/[0.06] pb-3">
                <div className="flex items-center gap-3">
                  <CalendarDays className="w-4 h-4 text-emerald-400" />
                  <span className="text-gray-200">Daily</span>
                </div>

                <span className="font-semibold text-emerald-400">FREE</span>
              </div>

              <div className="flex items-center justify-between border-b border-white/[0.06] pb-3">
                <div className="flex items-center gap-3">
                  <CalendarDays className="w-4 h-4 text-emerald-400" />
                  <span className="text-gray-200">Weekly</span>
                </div>

                <span className="font-semibold text-emerald-400">FREE</span>
              </div>

              <div className="flex items-center justify-between border-b border-white/[0.06] pb-3">
                <div className="flex items-center gap-3">
                  <CalendarDays className="w-4 h-4 text-emerald-400" />
                  <span className="text-gray-200">Monthly</span>
                </div>

                <span className="font-semibold text-emerald-400">FREE</span>
              </div>

              <div className="flex items-center justify-between">
                <div className="flex items-center gap-3">
                  <CalendarDays className="w-4 h-4 text-emerald-400" />
                  <span className="text-gray-200">Yearly</span>
                </div>

                <span className="font-semibold text-emerald-400">FREE</span>
              </div>

              <div className="flex items-center justify-between h-3"></div>
              <div className="flex items-center justify-between h-3"></div>
            </div>

            <ul className="space-y-3 bullet-blk flex-grow min-h-[140px]--">
              <li className="flex items-center gap-3">
                <div className="w-5 h-5 rounded-full bg-violet-600/20 flex tick-cl items-center justify-center flex-shrink-0">
                  <Check className="w-3 h-3 white-text-400" />
                </div>
                <span className="text-gray-300 text-sm">
                  Quantum safe encryption
                </span>
              </li>
              <li className="flex items-center gap-3">
                <div className="w-5 h-5 rounded-full bg-violet-600/20 flex tick-cl items-center justify-center flex-shrink-0">
                  <Check className="w-3 h-3 white-text-400" />
                </div>
                <span className="text-gray-300 text-sm">
                  Limited server access with ads
                </span>
              </li>
              <li className="flex items-center gap-3">
                <div className="w-5 h-5 rounded-full bg-violet-600/20 flex tick-cl items-center justify-center flex-shrink-0">
                  <Check className="w-3 h-3 white-text-400" />
                </div>
                <span className="text-gray-300 text-sm">Supports 1 device</span>
              </li>
            </ul>

            <Link to="/#download">
              <Button className="w-full btn-gradient1 btn-gradient-new">
                Get Started <ChevronRight className="w-4 h-4 ml-2" />
              </Button>
            </Link>
          </div>{" "}
          {/* Plan 1 */}
          <div
            className="group relative overflow-visible p-8 rounded-3xl flex flex-col mob-bottoms h-full transition-all duration-500
                ease-out hover:-translate-y-2 hover:scale-[1.01] hover:shadow-[0_0_35px_rgba(16,185,129,0.12)] mb-10- cardbg"
          >
            <div className="absolute -top-3 left-6 w-max z-10">
              <span className="px-4 py-1 rounded-full tag">Popular</span>
            </div>

            <div className="mb-6">
              <h2 className="text-2xl font-bold text-white mb-1">PREMIUM</h2>
              {/* <p className="white-text-400 text-sm">DURATION</p> */}
            </div>

            <div className="mb-6">
              <div className="flex items-baseline">
                <span className="text-3xl md:text-5xl font-bold text-white">
                  $2{" "}
                  <span className="text-xl font-light text-white">/Daily</span>
                </span>
              </div>
              <div className="text-sm white-text-4001 text-gray-300 mt-2">
                Flexible premium plans
              </div>
              {/* <div className="text-sm white-text-400 mt-2">PER</div>
                <div className="text-xs white-text-500 mt-1">BILLING</div> */}
              {/* <div className="inline-block mt-3 px-2 py-0.5 text-xl font-medium text-emerald-400 bg-emerald-500/10 rounded-full">
                    Save 50%
                  </div> */}
            </div>

            <div className="border-t border-white/10 pt-3 mb-8 space-y-4">
              <div className="flex items-center justify-between border-b border-white/[0.06] pb-3">
                <div className="flex items-center gap-3">
                  <CalendarDays className="w-4 h-4 text-emerald-400" />
                  <span className="text-gray-200">Daily</span>
                </div>

                <span className="font-semibold text-white-400">$2.00</span>
              </div>

              <div className="flex items-center justify-between border-b border-white/[0.06] pb-3">
                <div className="flex items-center gap-3">
                  <CalendarDays className="w-4 h-4 text-emerald-400" />
                  <span className="text-gray-200">Weekly</span>
                </div>

                <span className="font-semibold text-white-400">$8.00</span>
              </div>

              <div className="flex items-center justify-between border-b border-white/[0.06] pb-3">
                <div className="flex items-center gap-3">
                  <CalendarDays className="w-4 h-4 text-emerald-400" />
                  <span className="text-gray-200">Monthly</span>
                </div>

                <span className="font-semibold text-white-400">$20.00</span>
              </div>

              <div className="flex items-center justify-between border-b border-white/[0.06] pb-3">
                <div className="flex items-center gap-3">
                  <CalendarDays className="w-4 h-4 text-emerald-400" />
                  <span className="text-gray-200">Yearly</span>
                </div>

                <span className="font-semibold text-white-400">$100.00</span>
              </div>

              <div className="flex items-center justify-between">
                <div className="flex items-center gap-3">
                  <CalendarDays className="w-4 h-4 text-emerald-400" />

                  <span className="text-gray-200">Yearly (Pay Monthly)</span>

                  {/* Tooltip */}
                  <div className="relative">
                    <Info className="peer w-4 h-4 text-emerald-400/80 cursor-pointer" />

                    <div className="absolute bottom-full left-1/2 mb-3 w-72 -translate-x-1/2 rounded-xl border border-emerald-500/20 bg-[#08120f] p-4 text-sm leading-6 text-gray-300 opacity-0 invisible transition-all duration-300 peer-hover:opacity-100 peer-hover:visible z-20 shadow-[0_10px_30px_rgba(0,0,0,0.45)]">
                      $12.50/mo Commit to 1 year. Pay monthly. Cancel anytime
                      after 12 months.
                    </div>
                  </div>
                </div>

                <span className="font-semibold text-white-400">$150.00</span>
              </div>
              {/**/}
            </div>

            <ul className="space-y-3 bullet-blk flex-grow min-h-[140px]--">
              <li className="flex items-center gap-3">
                <div className="w-5 h-5 rounded-full bg-violet-600/20 flex tick-cl items-center justify-center flex-shrink-0">
                  <Check className="w-3 h-3 white-text-400" />
                </div>
                <span className="text-gray-300 text-sm">
                  Everything in Standard
                </span>
              </li>
              <li className="flex items-center gap-3">
                <div className="w-5 h-5 rounded-full bg-violet-600/20 flex tick-cl items-center justify-center flex-shrink-0">
                  <Check className="w-3 h-3 white-text-400" />
                </div>
                <span className="text-gray-300 text-sm">
                  Access to premium servers
                </span>
              </li>
              <li className="flex items-center gap-3">
                <div className="w-5 h-5 rounded-full bg-violet-600/20 flex tick-cl items-center justify-center flex-shrink-0">
                  <Check className="w-3 h-3 white-text-400" />
                </div>
                <span className="text-gray-300 text-sm">Priority support</span>
              </li>
              <li className="flex items-center gap-3">
                <div className="w-5 h-5 rounded-full bg-violet-600/20 flex tick-cl items-center justify-center flex-shrink-0">
                  <Check className="w-3 h-3 white-text-400" />
                </div>
                <span className="text-gray-300 text-sm">
                  Early access to new features
                </span>
              </li>
              <li className="flex items-center gap-3">
                <div className="w-5 h-5 rounded-full bg-violet-600/20 flex tick-cl items-center justify-center flex-shrink-0">
                  <Check className="w-3 h-3 white-text-400" />
                </div>
                <span className="text-gray-300 text-sm">Faster speeds</span>
              </li>
              <li className="flex items-center gap-3">
                <div className="w-5 h-5 rounded-full bg-violet-600/20 flex tick-cl items-center justify-center flex-shrink-0">
                  <Check className="w-3 h-3 white-text-400" />
                </div>
                <span className="text-gray-300 text-sm">
                  Supports up to 3 devices
                </span>
              </li>
              <li className="flex items-center gap-3">
                <div className="w-5 h-5 rounded-full bg-violet-600/20 flex tick-cl items-center justify-center flex-shrink-0">
                  <Check className="w-3 h-3 white-text-400" />
                </div>
                <span className="text-gray-300 text-sm">
                  Ad-free experience
                </span>
              </li>
            </ul>

            <Link to="/#download">
              <Button className="w-full btn-gradient1 btn-gradient-new">
                Get Started <ChevronRight className="w-4 h-4 ml-2" />
              </Button>
            </Link>
          </div>{" "}
          {/* Plan 2 */}
          <div
            className="group relative overflow-visible p-8 rounded-3xl flex flex-col mob-bottoms h-full transition-all duration-500
                ease-out hover:-translate-y-2 hover:scale-[1.01] hover:shadow-[0_0_35px_rgba(16,185,129,0.12)] mb-10- bg-white/[0.03] border border-white/10 cardbg1"
          >
            <div className="absolute -top-3 left-6 w-max z-10">
              <span className="px-4 py-1 rounded-full tag">Best Value</span>
            </div>

            <div className="mb-6">
              <h2 className="text-2xl font-bold text-white mb-1">PRO</h2>
              {/* <p className="white-text-400 text-sm">DURATION</p> */}
            </div>

            <div className="mb-6">
              <div className="flex items-baseline">
                <span className="text-3xl md:text-5xl font-bold text-white">
                  $3{" "}
                  <span className="text-xl font-light text-white">/Daily</span>
                </span>
              </div>
              <div className="text-sm white-text-4001 text-gray-300 mt-2">
                Maximum performance & security
              </div>
              {/* <div className="text-sm white-text-400 mt-2">PER</div>
                <div className="text-xs white-text-500 mt-1">BILLING</div> */}
              {/* <div className="inline-block mt-3 px-2 py-0.5 text-xl font-medium text-emerald-400 bg-emerald-500/10 rounded-full">
                    Save 50%
                  </div> */}
            </div>

            <div className="border-t border-white/10 pt-3 mb-8 space-y-4">
              <div className="flex items-center justify-between border-b border-white/[0.06] pb-3">
                <div className="flex items-center gap-3">
                  <CalendarDays className="w-4 h-4 text-emerald-400" />
                  <span className="text-gray-200">Daily</span>
                </div>

                <span className="font-semibold text-white-400">$3.00</span>
              </div>

              <div className="flex items-center justify-between border-b border-white/[0.06] pb-3">
                <div className="flex items-center gap-3">
                  <CalendarDays className="w-4 h-4 text-emerald-400" />
                  <span className="text-gray-200">Weekly</span>
                </div>

                <span className="font-semibold text-white-400">$10.00</span>
              </div>

              <div className="flex items-center justify-between border-b border-white/[0.06] pb-3">
                <div className="flex items-center gap-3">
                  <CalendarDays className="w-4 h-4 text-emerald-400" />
                  <span className="text-gray-200">Monthly</span>
                </div>

                <span className="font-semibold text-white-400">$25.00</span>
              </div>

              <div className="flex items-center justify-between border-b border-white/[0.06] pb-3">
                <div className="flex items-center gap-3">
                  <CalendarDays className="w-4 h-4 text-emerald-400" />
                  <span className="text-gray-200">Yearly</span>
                </div>

                <span className="font-semibold text-white-400">$150.00</span>
              </div>

              <div className="flex items-center justify-between">
                <div className="flex items-center gap-3">
                  <CalendarDays className="w-4 h-4 text-emerald-400" />

                  <span className="text-gray-200">Yearly (Pay Monthly)</span>

                  {/* Tooltip */}
                  <div className="relative">
                    <Info className="peer w-4 h-4 text-emerald-400/80 cursor-pointer" />

                    <div className="absolute bottom-full left-1/2 mb-3 w-72 -translate-x-1/2 rounded-xl border border-emerald-500/20 bg-[#08120f] p-4 text-sm leading-6 text-gray-300 opacity-0 invisible transition-all duration-300 peer-hover:opacity-100 peer-hover:visible z-20 shadow-[0_10px_30px_rgba(0,0,0,0.45)]">
                      $16.66/mo Commit to 1 year. Pay monthly. Cancel anytime
                      after 12 months.
                    </div>
                  </div>
                </div>

                <span className="font-semibold text-white-400">$200.00</span>
              </div>
              {/**/}
            </div>

            <ul className="space-y-3 bullet-blk flex-grow min-h-[140px]--">
              <li className="flex items-center gap-3">
                <div className="w-5 h-5 rounded-full bg-violet-600/20 flex tick-cl items-center justify-center flex-shrink-0">
                  <Check className="w-3 h-3 white-text-400" />
                </div>
                <span className="text-gray-300 text-sm">
                  Everything in Premium
                </span>
              </li>
              <li className="flex items-center gap-3">
                <div className="w-5 h-5 rounded-full bg-violet-600/20 flex tick-cl items-center justify-center flex-shrink-0">
                  <Check className="w-3 h-3 white-text-400" />
                </div>
                <span className="text-gray-300 text-sm">
                  Maximum speeds (zero throttling)
                </span>
              </li>
              <li className="flex items-center gap-3">
                <div className="w-5 h-5 rounded-full bg-violet-600/20 flex tick-cl items-center justify-center flex-shrink-0">
                  <Check className="w-3 h-3 white-text-400" />
                </div>
                <span className="text-gray-300 text-sm">
                  Lowest price guaranteed
                </span>
              </li>
              <li className="flex items-center gap-3">
                <div className="w-5 h-5 rounded-full bg-violet-600/20 flex tick-cl items-center justify-center flex-shrink-0">
                  <Check className="w-3 h-3 white-text-400" />
                </div>
                <span className="text-gray-300 text-sm">
                  All server locations
                </span>
              </li>
              <li className="flex items-center gap-3">
                <div className="w-5 h-5 rounded-full bg-violet-600/20 flex tick-cl items-center justify-center flex-shrink-0">
                  <Check className="w-3 h-3 white-text-400" />
                </div>
                <span className="text-gray-300 text-sm">
                  Supports up to 5 devices
                </span>
              </li>
            </ul>

            <Link to="/#download">
              <Button className="w-full btn-gradient1 btn-gradient-new">
                Get Started <ChevronRight className="w-4 h-4 ml-2" />
              </Button>
            </Link>
          </div>{" "}
          {/* Plan 3 */}
        </div>
      </div>
    </section>
  );
};

// Free Tier Callout (NEW)
const FreeTierCalloutSection = () => {
  const { freeTier } = PRICING_CONFIG;

  return (
    <section
      className="relative py-161 md:py-201 free-padd bg-black-v1"
      data-testid="free-tier-callout-section"
    >
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="rounded-3xl bg-white/[0.03] border border-white/10 p-8 md:p-10">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 items-center">
            {/* Left: Title + body */}
            <div className="md:col-span-1">
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-xl flex items-center justify-center tryimg">
                  {/* <Sparkles className="w-5 h-5 text-violet-300" /> */}
                  <img src={tryqvpnImg} alt="Try QVPN" />
                </div>
                <h3 className="text-2xl font-bold text-white">
                  {freeTier.name}
                </h3>
              </div>
              <p className="text-gray-400 text-sm">{freeTier.body}</p>
            </div>

            {/* Middle: Features */}
            <div className="md:col-span-1">
              <ul className="space-y-3">
                {freeTier.features.map((feature, i) => (
                  <li key={i} className="flex items-center gap-3">
                    <div className="w-5 h-5 rounded-full bg-violet-600/20 flex items-center justify-center flex-shrink-0 tick-cl">
                      <Check className="w-3 h-3 white-text-400" />
                    </div>
                    <span className="text-gray-300 text-sm">{feature}</span>
                  </li>
                ))}
              </ul>
            </div>

            {/* Right: CTA */}
            <div className="md:col-span-1 flex md:justify-end">
              <Link onClick={() => scrollToSection("download")}>
                <Button
                  className="btn-primary1 btn-gradient-new inline-flex items-center gap-2 btn-padd"
                  data-testid="free-tier-cta"
                >
                  {freeTier.cta}
                  <ChevronRight className="w-4 h-4" />
                </Button>
              </Link>
            </div>
          </div>
        </div>

        <p className="text-center text-gray-500 text-sm mt-6 mb-8">
          {freeTier.subtext}
        </p>
      </div>
    </section>
  );
};

// Final CTA Section
const CTASection = () => {
  return (
    <section
      className="relative overflow-hidden py-24 md:py-32 cta-gradient go-padd"
      data-testid="cta-section"
    >
      <StarField />

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10">
        <div className="w-16 h-16 mx-auto mb-81 ready-icon-padd rounded-2xl flex items-center justify-center animate-pulse-glow goimg">
          {/* <Shield className="w-8 h-8 text-white" /> */}
          <img
            src={goquantumImg}
            alt="Ready to Go Quantum?"
            className="govpnimg"
          />
        </div>

        <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight mb-8 animate-fade-in-up">
          Ready to Go Quantum?
        </h2>

        <p className="text-base md:text-lg text-gray-400 max-w-xl mx-auto mb-10">
          Download QVPN today and take control of your online privacy. Start
          with the free plan or go Quantum Pro for unlimited protection.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            onClick={() => scrollToSection("download")}
            className="btn-gradient1 btn-gradient-new flex items-center gap-2 h-14 px-10"
            data-testid="cta-download-btn"
          >
            <Download className="w-5 h-5 " />
            Download Now
          </Link>
          <Link to="/contact">
            <Button
              className="btn-secondary1 btn-gradient-new  text-md flex items-center gap-2 h-14 px-10"
              data-testid="cta-contact-btn"
            >
              Contact Support
              <ChevronRight className="w-5 h-5" />
            </Button>
          </Link>
        </div>
      </div>

      <div className="glow-orb2 glow-orb-purple w-[500px] h-[500px] absolute pointer-events-none left-[15%] -translate-x-[50%] -bottom-[340px]" />
    </section>
  );
};

// Main Home Page Component
export const HomePage = () => {
  return (
    <>
      <HeroSection />
      <FeatureIconsRow />
      <WhatIsSection />
      <UseCasesSection />
      <FeaturesSection />
      <HowItWorksSection />
      <WhyQuantumSection />
      <ComparisonSection />
      <DeviceCompatibilitySection />
      <PricingPreviewSection />
      <FreeTierCalloutSection />
      <CTASection />
    </>
  );
};

export default HomePage;
